// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3H3AX","tabsBox":"styles_tabsBox__2rCNv","createButton":"styles_createButton__3Ug_4"};